module.exports = "https://cdn-shared.mathletics.com/teacher-modules/curriculum-manager/15assets/fonts/19d630ecf67b30504f0f035a5922ffac.svg";


//////////////////
// WEBPACK FOOTER
// ./~/font-awesome-sass/assets/fonts/font-awesome/fontawesome-webfont.svg?v=4.7.0
// module id = 672
// module chunks = 4